














 









































































const node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dragId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dropTargetId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dropTargetType"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reflectionId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "dragId",
    "variableName": "dragId"
  },
  {
    "kind": "Variable",
    "name": "dropTargetId",
    "variableName": "dropTargetId"
  },
  {
    "kind": "Variable",
    "name": "dropTargetType",
    "variableName": "dropTargetType"
  },
  {
    "kind": "Variable",
    "name": "reflectionId",
    "variableName": "reflectionId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "RetrospectiveMeeting",
  "kind": "LinkedField",
  "name": "meeting",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nextAutoGroupThreshold",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "teamId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "promptId",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isViewerCreator",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reflectionGroupId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isEditing",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isViewerDragging",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDropping",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dragUserId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dragUserName",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSpotlight",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "targetId",
  "storageKey": null
},
v17 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "ReflectionCard_reflection"
  },
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "RemoteReflection_reflection"
  },
  (v5/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/),
  {
    "kind": "ClientExtension",
    "selections": [
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "RemoteReflectionDrag",
        "kind": "LinkedField",
        "name": "remoteDrag",
        "plural": false,
        "selections": [
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/)
        ],
        "storageKey": null
      }
    ]
  }
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingId",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sortOrder",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "voteCount",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "RetroReflectionGroup",
  "kind": "LinkedField",
  "name": "oldReflectionGroup",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v20/*: any*/)
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dropTargetType",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dropTargetId",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userId",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "RemoteReflectionDrag",
  "kind": "LinkedField",
  "name": "remoteDrag",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v13/*: any*/),
    (v14/*: any*/),
    (v15/*: any*/)
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "preferredName",
  "storageKey": null
},
v28 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ReflectPrompt",
    "kind": "LinkedField",
    "name": "prompt",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "question",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "groupColor",
        "storageKey": null
      },
      (v5/*: any*/)
    ],
    "storageKey": null
  },
  (v8/*: any*/),
  (v5/*: any*/),
  (v18/*: any*/),
  (v9/*: any*/),
  (v7/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "content",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Reactji",
    "kind": "LinkedField",
    "name": "reactjis",
    "plural": true,
    "selections": [
      (v5/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "count",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isViewerReactji",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "users",
        "plural": true,
        "selections": [
          (v5/*: any*/),
          (v27/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  (v19/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "creator",
    "plural": false,
    "selections": [
      (v27/*: any*/),
      (v5/*: any*/)
    ],
    "storageKey": null
  },
  {
    "kind": "ClientExtension",
    "selections": [
      (v10/*: any*/),
      (v12/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "RemoteReflectionDrag",
        "kind": "LinkedField",
        "name": "remoteDrag",
        "plural": false,
        "selections": [
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientHeight",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientWidth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientX",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientY",
            "storageKey": null
          },
          (v16/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "targetOffsetX",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "targetOffsetY",
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      (v11/*: any*/)
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "EndDraggingReflectionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "EndDraggingReflectionPayload",
        "kind": "LinkedField",
        "name": "endDraggingReflection",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RetroReflection",
            "kind": "LinkedField",
            "name": "reflection",
            "plural": false,
            "selections": (v17/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RetroReflectionGroup",
            "kind": "LinkedField",
            "name": "reflectionGroup",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RetroReflection",
                "kind": "LinkedField",
                "name": "reflections",
                "plural": true,
                "selections": (v17/*: any*/),
                "storageKey": null
              },
              (v20/*: any*/),
              (v21/*: any*/)
            ],
            "storageKey": null
          },
          (v22/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          (v26/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "EndDraggingReflectionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "EndDraggingReflectionPayload",
        "kind": "LinkedField",
        "name": "endDraggingReflection",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RetroReflection",
            "kind": "LinkedField",
            "name": "reflection",
            "plural": false,
            "selections": (v28/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RetroReflectionGroup",
            "kind": "LinkedField",
            "name": "reflectionGroup",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RetroReflection",
                "kind": "LinkedField",
                "name": "reflections",
                "plural": true,
                "selections": (v28/*: any*/),
                "storageKey": null
              },
              (v20/*: any*/),
              (v21/*: any*/)
            ],
            "storageKey": null
          },
          (v22/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          (v26/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "m_UbK6cep83vQEZtypW2-ang",
    "metadata": {},
    "name": "EndDraggingReflectionMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node ).hash = "2a4b217de19beb86e78b6fb4f875dcba";

export default node;
